import React from 'react';
import { screenSmMax, screenSmMin, screenXxsMax, spacer12, spacer24, spacer48, Type, } from '@spotify-internal/encore-web';
import styled from 'styled-components';
import { useFooterLinks } from './useFooterLinks';
import { Link } from '../Link/Link';
import { FooterTextLink } from './Link';
const ColumnsContainer = styled.div `
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: ${spacer24};
  flex: none;
  align-self: stretch;
  flex-grow: 0;
  width: 58%;
  @media (max-width: ${screenSmMax}) {
    order: 1;
    width: 100%;
  }
  @media (max-width: ${screenXxsMax}) {
    order: 1;
    width: 100%;
    flex-direction: column;
    gap: ${spacer48};
  }
`;
const Column = styled.div `
  display: flex;
  flex-direction: column;
  padding: 0px;
  gap: ${spacer24};
  flex: none;
  flex-grow: 0;
  &:first-of-type {
    order: 1;
    @media (max-width: ${screenSmMax}) {
      order: 0;
    }
    // calculation accounts for gap
    width: calc((28% - 16px));
    @media (min-width: ${screenSmMin}) and (max-width: ${screenSmMax}) {
      // calculation accounts for gap
      width: calc(38% - 16px);
    }
    @media (max-width: ${screenXxsMax}) {
      width: 100%;
    }
  }
  :not(:first-of-type),
  :not(:last-of-type) {
    order: 2;
    @media (max-width: ${screenSmMax}) {
      order: 1;
    }
    // calculation accounts for gap
    width: calc(28% - 16px);
    @media (min-width: ${screenSmMin}) and (max-width: ${screenSmMax}) {
      // calculation accounts for gap
      width: calc(38% - 16px);
    }
    @media (max-width: ${screenXxsMax}) {
      width: 100%;
    }
  }
  &:last-of-type {
    order: 3;
    @media (max-width: ${screenSmMax}) {
      order: 2;
    }
    // calculation accounts for gap
    width: calc(44% - 16px);
    @media (min-width: ${screenSmMin}) and (max-width: ${screenSmMax}) {
      // calculation accounts for gap
      width: calc(24% - 16px);
    }
    @media (max-width: ${screenXxsMax}) {
      width: 100%;
    }
  }
`;
const LinkList = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: ${spacer24};
`;
const AppsList = styled(LinkList) `
  gap: ${spacer12};

  & > a:focus {
    outline: 5px auto -webkit-focus-ring-color;
    outline-offset: -2px;
  }

  & img {
    display: block;
    max-inline-size: 100%;
    block-size: auto;
  }
`;
const StyledType = styled(Type) `
  text-transform: uppercase;
`;
export const FooterContent = ({ getTranslation, trackCat, colors }) => {
    const { creatorTools, helpfulLinks } = useFooterLinks({
        trackCat,
        getTranslation,
    });
    return (React.createElement(ColumnsContainer, null,
        React.createElement(Column, null,
            React.createElement(StyledType, { variant: "finaleBold" }, getTranslation('FRODOR_0aeec8')),
            React.createElement(LinkList, null, helpfulLinks.map(link => {
                return (React.createElement(FooterTextLink, Object.assign({ key: link.label }, link, { colors: colors }), link.label));
            }))),
        React.createElement(Column, null,
            React.createElement(StyledType, { variant: "finaleBold" }, getTranslation('FRODOR_d0bb36')),
            React.createElement(LinkList, null, creatorTools.map(link => {
                return (React.createElement(FooterTextLink, Object.assign({ key: link.label }, link, { colors: colors }), link.label));
            }))),
        React.createElement(Column, null,
            React.createElement(StyledType, { variant: "finaleBold" }, getTranslation('FRODOR_GET_THE_APP_SECTION_HEADER_FOOTER')),
            React.createElement(AppsList, null,
                React.createElement(Link, { dataTestId: "footer-ios", external: true, href: "https://itunes.apple.com/us/app/spotify-for-artists/id1222021797", track: [trackCat, 'iOS App'] },
                    React.createElement("img", { src: "https://mrkt-web.scdn.co/artists-spotify-com/_next/static/images/footer-ios-a77e2676a3ffba2c521ce743a6d82eea.svg", alt: getTranslation('FRODOR_S4A_APP_STORE') })),
                React.createElement(Link, { dataTestId: "footer-android", external: true, href: "https://play.google.com/store/apps/details?id=com.spotify.s4a", track: [trackCat, 'Android App'] },
                    React.createElement("img", { src: "https://mrkt-web.scdn.co/artists-spotify-com/_next/static/images/footer-android-1e8a7815136447656dae5d9e77dfd5ad.svg", alt: getTranslation('FRODOR_S4A_GOOGLE_PLAY') }))))));
};
//# sourceMappingURL=Content.js.map